import { UUID } from "action/interfaces/uuid.interface";
import axios from "fetch-api/fetch-api";

export function getUuid() {
  return axios.post<UUID>("/get-signifyd-uuid");
}
